import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Z_INDEX, zStyle } from '../../../lib/zLayers';
import { viewLabel } from '../../../i18n/labels';
import { cn } from '../../../lib/utils';
import type { MenuItemView } from '../Sidebar';
import { sidebarViewsMenuClass, sidebarViewsMenuItemClass } from './sidebarDesign';

export interface AppSidebarViewsMenuProps {
  open: boolean;
  top: number;
  left: number;
  views: MenuItemView[];
  currentPath: string;
  onSelect: (path: string) => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const AppSidebarViewsMenu: React.FC<AppSidebarViewsMenuProps> = ({
  open,
  top,
  left,
  views,
  currentPath,
  onSelect,
  onMouseEnter,
  onMouseLeave,
}) => {
  const { t } = useTranslation('sidebar');

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div
      className={cn('fixed', sidebarViewsMenuClass())}
      style={{
        top,
        left: left + 6,
        ...zStyle(Z_INDEX.shellFlyoutNested),
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <p className="px-3 pb-1 pt-2 text-[10px] font-semibold uppercase tracking-wider text-slate-500">
        Views
      </p>
      {views.map((view, idx) => {
        const active = currentPath === view.path || currentPath.startsWith(`${view.path}/`);
        return (
          <button
            key={idx}
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onSelect(view.path);
            }}
            className={sidebarViewsMenuItemClass(active)}
          >
            <span className="flex h-4 w-4 shrink-0 items-center justify-center">{view.icon}</span>
            {viewLabel(t, view.label)}
          </button>
        );
      })}
    </div>,
    document.body,
  );
};

export default AppSidebarViewsMenu;
